module.exports = __webpack_public_path__ + "/images/shop/filter-select/geely.png";